import {ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from "@angular/router";

import {hunLinkMixin} from "../../mixins/hun-link.mixin";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";

function isHunLink(tar: any): boolean {
  return tar instanceof HTMLAnchorElement && tar.className === 'hunlink';
}


@Component({
  selector: 'app-hun-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container #container></ng-container>
    <div class="txt-context"
         [innerHTML]="content | keepHtml"></div>
    <b>&nbsp;{{ pronunciation }}</b>
  `,
  styleUrls: ['./hun-content.component.scss'],
})
export class HunContentComponent extends hunLinkMixin implements OnInit, OnDestroy {
  // @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() content: string | null = null;
  @Input() pronunciation: string | null = null;

  private unlisten: (() => void) | null = null;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  ngOnInit(): void {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      let tar = event.target;

      // TODO: tar.className === 'hanja-size' 는 추후에 제거해야할지 고민이 필요. 링크 안의 테그가 다양해지면 매번 여기에 추가하는 것도 번거로움.
      if (isHunLink(tar) || (tar.className === 'hanja-size' && isHunLink(tar.parentElement))) {

        // 링크 안에 한자를 클릭한 경우에는 부모 요소로 대체한다.
        if ((tar.className === 'hanja-size' && isHunLink(tar.parentElement))) {
          tar = tar.parentElement;
        }

        event.preventDefault();
        event.stopPropagation();
        this.globalEventSvc.Click(event, true);

        console.log('anchor click = ', event, event.target.innerText);

        const url = decodeURI(tar.pathname);
        console.log('url = ', url);

        const href = tar.getAttribute('href');
        if (href) {
          const dispTxt = event.target.innerText.replace(/[:_\/-]/g, "");
          console.warn('dispTxt = ', dispTxt);
          // TODO:
          if (this.lm.vcRef) {
            this.OpenHunLink(href, dispTxt).subscribe();
          } else {
            console.error('LinkContentComponent: this.lm.vcRef is null');
          }
        } else {
          throw new Error('LinkContentComponent: href is null');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

}
